import { List as IList } from 'immutable';

export const selectCountriesList = (state) => state.registerReducer.get('countriesList', IList());
export const selectIndustriesList = (state) => state.registerReducer.get('industriesList', IList());
export const selectEmailExists = (state) => state.registerReducer.get('emailExists');
